module.exports = __webpack_public_path__ + "img/nfl-news.5be8e152.png";